import Block from './Block'
import Splide from '@splidejs/splide'
import gsap from 'gsap'
import store from '../util/store'

export default class SliderCardsBis extends Block {
  getElems() {
    this.sliderContainer = this.el.querySelector('.splide')
    this.slider = null
    this.initialSlides = Array.from(this.el.querySelectorAll('.splide__slide')).map((slide) => this._explodeSlide(slide))
    this.slides = []
    this.cursor = store.cursor
    this.inactiveImageBottom = 0
    this.nav = {
      prev: this.el.querySelector('.splide__nav .prev'),
      next: this.el.querySelector('.splide__nav .next')
    }
  }

  init() {
    if (store.detect.isMobile || store.w.w < 1200) return

    this.slider = new Splide(this.sliderContainer, {
      pagination: false,
      arrows: false,
      perPage: 3,
      perMove: 1,
      lazyLoad: false,
      type: 'loop',
      gap: 2000 / 1512 + 'vw',
      autoWidth: true
      // autoplay: true
    }).mount()

    this.slides = Array.from(this.el.querySelectorAll('.splide__slide')).map((slide) => this._explodeSlide(slide))

    this.initialSlides.forEach(({ contentTitle }) => {
      if (contentTitle.offsetHeight > this.inactiveImageBottom - 24) {
        this.inactiveImageBottom = contentTitle.offsetHeight + 24
      }
    })

    this.slides.forEach((slide) => {
      if (slide.el === this.initialSlides[0].el) {
        slide.el.classList.add('--active')

        gsap.set(slide.el, {
          height: 66000 / 1512 + 'vw'
        })

        gsap.set(slide.image, {
          bottom: '0vw'
        })
      } else {
        gsap.set(slide.image, {
          bottom: this.inactiveImageBottom * 100 / 1512 + 'vw'
        })

        gsap.set(slide.content, {
          y: slide.contentTextHeight
        })
      }
    })
  }

  events() {
    if (store.detect.isMobile || store.w.w < 1200) return

    this.slider.on('move', (newIndex, prevIndex) => this._handleMove(newIndex, prevIndex))

    this.slides.forEach((slide) => {
      slide.link.addEventListener('mouseenter', () => {
        if (slide.el.classList.contains('--active')) {
          this.cursor.addState('-xl -white-full')
        } else {
          this.cursor.addState('-l -white-full')
        }

        this.cursor.setIcon('resources--assets--images--svg--arrow-external-big')
      })

      slide.link.addEventListener('mouseleave', () => {
        if (slide.el.classList.contains('--active')) {
          this.cursor.removeState('-xl -white-full')
        } else {
          this.cursor.removeState('-l -white-full')
        }

        this.cursor.removeIcon()
      })
    })

    if (this.nav) {
      this.nav.prev.addEventListener('click', () => {
        this.slider.go('<')
      })

      this.nav.next.addEventListener('click', () => {
        this.slider.go('>')
      })
    }
  }

  _handleMove(newIndex, prevIndex) {
    const prevSlide = this.initialSlides[prevIndex]
    const newSlide = this.initialSlides[newIndex]

    prevSlide.el.classList.remove('--active')
    newSlide.el.classList.add('--active')

    const tl = gsap.timeline({
      paused: true,
      defaults: {
        ease: 'power3.out',
        duration: 0.3
      }
    })

    tl.to(prevSlide.el, {
      height: 40500 / 1512 + 'vw'
    }, '<')

    tl.to(prevSlide.image, {
      bottom: this.inactiveImageBottom * 100 / 1512 + 'vw'
    }, '<')

    tl.to(prevSlide.content, {
      y: prevSlide.contentTextHeight
    }, '<')

    tl.to(newSlide.el, {
      height: 66000 / 1512 + 'vw'
    }, '<')

    tl.to(newSlide.image, {
      bottom: '0vw'
    }, '<')

    tl.to(newSlide.content, {
      y: '0vw'
    }, '<')

    tl.play()
  }

  _explodeSlide(slide) {
    return {
      el: slide,
      link: slide.querySelector('a'),
      image: slide.querySelector('.image'),
      content: slide.querySelector('.splide__slide__content'),
      contentTitle: slide.querySelector('.splide__slide__content__title'),
      contentText: slide.querySelector('.splide__slide__content p'),
      contentTextHeight: slide.querySelector('.splide__slide__content p').offsetHeight
    }
  }
}
